<div class="mui-bell-icon-container" [class.isAnimating]="isAnimating()">
  <svg version="1.1" class='notification-bell' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92"
       aria-hidden="true">
    <path class="notification-bell__top bell" d="M80.5,66.5c-1.1,2.8-3.9,4.7-7,4.7h-55c-3.1,0-5.8-1.8-7-4.7c-1.1-2.8-0.4-5.9,1.8-8 C17.6,54.4,21,50,21,35.3c0-12.4,9.9-22.6,22.5-23.8V8.7c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.7C61.1,12.7,71,22.8,71,35.3 c0,14.8,3.3,19.1,7.7,23.3C80.9,60.6,81.6,63.8,80.5,66.5z M75.3,62.2C69.8,56.9,66,51.1,66,35.3c0-10.5-9-19.1-20-19.1
	s-20,8.5-20,19.1c0,15.9-3.8,21.7-9.3,26.9c-1.6,1.5-0.5,4.1,1.8,4.1h55C75.7,66.2,76.8,63.7,75.3,62.2z"/>
    <path class="notification-bell__bottom bell"
          d="M51.1,76.1h5c0,5.5-4.5,10-10,10s-10-4.5-10-10h5c0,2.8,2.2,5,5,5S51.1,78.8,51.1,76.1z"/>
  </svg>
  <mui-number-badge [count]="_count" [disableDelay]="true" [label]="label"></mui-number-badge>
</div>
